'use client';

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';


const mockTests = [
  {
    id: 1,
    name: 'ETS - TOEFL',
    price: 49,
    description:
      'Prepare for the TOEFL exam with real ETS-style questions and evaluation.',
    image: '/image/mock/ets-toefl.png',
  },
  {
    id: 2,
    name: 'SFE - SELT',
    price: 49,
    description:
      'Ace your SELT exam with this carefully curated mock test.',
    image: '/image/mock/selt-ukvi.png',
  },
  {
    id: 3,
    name: 'Pearson Versant',
    price: 499,
    description:
      'Complete mock test for Pearson Versant with instant feedback.',
    image: '/image/mock/pte.png',
  },
];

const OnlinePayment = () => {
  const navigate = useNavigate();

  const handleBuyNow = (test) => {
    navigate('/checkout', {
      state: {
        product: {
          id: test.id,
          name: test.name,
          price: test.price,
          description: test.description,
          image: test.image,
          productType: 'ONLINE_PAYMENT', 
          buttonLabel: 'Pay Now',
        },
      },
    });
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-8 text-center">Mock Tests</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {mockTests.map((test) => (
          <div
            key={test.id}
            className="bg-white rounded-2xl shadow-md p-6 flex flex-col justify-between"
          >
            <div>
              {test.image && (
                <img
                  src={test.image}
                  alt={test.name}
                  className="w-full h-auto object-cover rounded-lg mb-4"
                />
              )}
              <h2 className="text-xl font-semibold mb-2">{test.name}</h2>
              <p className="text-gray-600 text-sm mb-4">{test.description}</p>
              <p className="text-lg font-bold text-blue-700">₹{test.price}</p>
            </div>
            <Button
              onClick={() => handleBuyNow(test)}
              className="mt-4 w-full"
            >
              Pay Now
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnlinePayment;
